export interface ICancelCustomerRequest {
  igsCustomerNumber: string;
  cancellationDate: Date;
  cancelReasonCode: string;
  cancelNotes: string;
}

export class CancelCustomerRequest implements ICancelCustomerRequest {
  igsCustomerNumber: string;
  cancellationDate: Date;
  cancelReasonCode: string;
  cancelNotes: string;
}
